import { Component, Element, h, Host, Prop } from '@stencil/core'
import { GridItemClass } from './constants'
import { govHost } from '../../helpers/Dom/template'
import { GovHost } from '../../helpers/Dom/template.types'

@Component({
	tag: 'gov-grid-item',
})
export class GovGridItem {
	private h: GovHost

	constructor() {
		this.h = govHost(this.host)
	}

	@Element() readonly host: HTMLGovGridItemElement
	/**
	 * Cell size as a fraction of 1/12 of the grid size
	 */
	@Prop({ attribute: 'col-span', reflect: true }) readonly column: string = "12";
	/**
	 * Cell size for SM media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'col-span-sm', reflect: true }) readonly columnSm?: string
	/**
	 * Cell size for MD media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'col-span-md', reflect: true }) readonly columnMd?: string
	/**
	 * Cell size for LG media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'col-span-lg', reflect: true }) readonly columnLg?: string
	/**
	 * Cell size for XL media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'col-span-xl', reflect: true }) readonly columnXl?: string
	/**
	 * Connects rows in the grid
	 */
	@Prop({ attribute: 'row-span', reflect: true }) readonly row: string = "1";
	/**
	 * Cell size for SM media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'row-span-sm', reflect: true }) readonly rowSm?: string
	/**
	 * Cell size for MD media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'row-span-md', reflect: true }) readonly rowMd?: string
	/**
	 * Cell size for LG media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'row-span-lg', reflect: true }) readonly rowLg?: string
	/**
	 * Cell size for XL media query and up as a fraction of 12 of the grid size
	 */
	@Prop({ attribute: 'row-span-xl', reflect: true }) readonly rowXl?: string


	render() {
		return (
			<Host
				class={this.h.classes(GridItemClass.root)}
				role="listitem"
			>
				<slot />
			</Host>
		)
	}
}
